import React from "react";

const CommentsScreen = () => {
  const items = [
    {
      id: 1,
      Comment:
        "Зал уже как родной 🙂 Приветливый персонал, уютная атмосфера. В особенности рекомендую тренера по имени Злата, профессионал своего дела! Отлично ведет групповые программы, а также помогает достичь идеальной фигуры в тренажерном зале👏",
      WrittenBy: "Mark Kucherov",
      Who: "Athletics, Trainer",
      Theme: "Отличный зал",
      Rating: 4,
    },
    {
      id: 2,
      Comment:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s...",
      WrittenBy: "Gayratbek Akhmedov",
      Who: "Athletic",
      Theme: "Good place",
      Rating: 5,
    },
  ];

  const [currentIndex, setCurrentIndex] = React.useState(0);

  // Move to the next comment
  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % items.length);
  };

  // Move to the previous comment
  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  // Dynamically renders gold or gray stars based on rating
  const renderStars = (rating) => {
    const goldStar = (
      <svg
        className="w-4 h-4 text-[#FFA722] ml-1"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 22 20"
      >
        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
      </svg>
    );

    const greyStar = (
      <svg
        className="w-4 h-4 text-gray-300 ml-1"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 22 20"
      >
        <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
      </svg>
    );

    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(i <= rating ? goldStar : greyStar);
    }
    return stars;
  };

  const currentItem = items[currentIndex];

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white py-6">
      <div className="w-full max-w-5xl px-4 sm:px-8">
        {/* Title + Apostrophes */}
        <div className="flex flex-col items-center text-center mb-8">
          {/* Apostrophes Row */}
          <div className="flex space-x-4 mb-4">
            <img
              src="aphostrophy.svg"
              alt="Decorative Apostrophe"
              className="w-8 h-8 sm:w-12 sm:h-12"
            />
            <img
              src="aphostrophy.svg"
              alt="Decorative Apostrophe"
              className="w-8 h-8 sm:w-12 sm:h-12"
            />
          </div>

          {/* Main Heading */}
          <h1 className="text-xl sm:text-3xl md:text-4xl font-bold text-slate-900">
            Отзывы от наших клиентов
          </h1>
          <p className="mt-2 text-sm sm:text-base md:text-lg text-[#426666] max-w-lg">
            ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.
          </p>

          {/* Logo (optional) */}
          <div className="mt-6">
            <img
              src="lum-logo.png"
              alt="Lum logo"
              className="w-32 sm:w-40 h-auto"
            />
          </div>
        </div>

        {/* Main content: comment + image/ratings row */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between bg-gray-50 rounded-xl p-6 md:p-8 shadow-md">
          {/* LEFT: Comment / Author */}
          <div className="md:max-w-[50%] text-gray-700">
            <p className="leading-relaxed">{currentItem.Comment}</p>
            <div className="mt-4">
              <h3 className="font-bold text-slate-900">{currentItem.WrittenBy}</h3>
              <p className="text-sm text-gray-600">{currentItem.Who}</p>
            </div>
          </div>

          {/* RIGHT: Rating + Theme + Muscle Image */}
          <div className="mt-6 md:mt-0 flex flex-col md:items-center md:w-[45%] md:text-center">
            {/* Stars + Check Icon */}
            <div className="flex items-center justify-center mb-3">
              <div className="flex">{renderStars(currentItem.Rating)}</div>
              <svg
                className="shrink-0 w-5 h-5 text-green-700 ml-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
              </svg>
            </div>
            {/* Theme */}
            <p className="text-sm sm:text-base text-gray-800 font-semibold">
              {currentItem.Theme}
            </p>
            {/* Muscle Image */}
            <img
              src="boy-muscle-image.png"
              alt="Muscle"
              className="mt-4 w-40 sm:w-48 md:w-60 h-auto mx-auto"
            />
          </div>
        </div>

        {/* Next / Prev Buttons */}
        <div className="flex justify-center space-x-10 mt-6">
          <button
            onClick={handlePrev}
            className="text-gray-700 hover:opacity-80 transition"
          >
            <img src="previous-page.svg" alt="Previous" className="w-8 h-8" />
          </button>
          <button
            onClick={handleNext}
            className="text-gray-700 hover:opacity-80 transition"
          >
            <img src="next-page.svg" alt="Next" className="w-8 h-8" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommentsScreen;
